module.exports = __webpack_public_path__ + "img/gongneng-4.cde68f98.png";